export const FIRST_STEP = 'first';
export const SECOND_STEP = 'second';
export const MAX_INPUT_LENGTH = 100;
